import Bronze from './bronze';
import Silver from './silver';
import Gold from './gold';
import Platinum from './platinum';
import Diamond from './diamond';

export default {
    Bronze,
    Silver,
    Gold,
    Platinum,
    Diamond
}